import { render, staticRenderFns } from "./modalAddFeaturedMatch.vue?vue&type=template&id=27149068&"
import script from "./modalAddFeaturedMatch.vue?vue&type=script&lang=js&"
export * from "./modalAddFeaturedMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports